import { defineComponent as _defineComponent } from 'vue'
import { modalService } from '@/library-services/modal.service';
import { computed, getCurrentInstance } from 'vue';
import PasswordResetModal from '../users/PasswordResetModal.vue';
import { usersService } from '@/services/users.service';
import { User, UserAuthenticationType } from '@/models/user';
import { useAuth, useSpinner } from '@/composables/misc';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN
 * Menu shown in the page header with information and actions for the logged-in
 * user.
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'UserMenu',
  emits: ['toggle:beta'],
  setup(__props, { emit }) {



const spinner = useSpinner();
const auth = useAuth();
const { t } = useI18n();

const app = getCurrentInstance();
function openResetPasswordModal() {
  modalService.compositionApi.open(
    {
      component: PasswordResetModal,
      props: {
        id: user.value.id,
        email: user.value.email,
      },
    },
    app,
  );
}

async function logOut() {
  spinner.showSpinner();
  usersService.store.update(null);
  await auth.logout().finally(() => spinner.removeSpinner());
}

const userInitials = computed((): string =>
  user.value.name
    ? user.value.name
        .split(' ')
        .map((nameWord) => nameWord[0])
        .slice(0, 2)
        .join('')
    : '',
);

const canChangePassword = computed(
  (): boolean => user.value.authenticationType === UserAuthenticationType.Local,
);

const isBetaEnabled = computed((): boolean => user.value.isBetaEnabled);
const canEnableBeta = computed((): boolean => user.value.hasAccessToBeta);
const user = computed((): User => usersService.store.current());

return { __sfc: true,emit, spinner, auth, t, app, openResetPasswordModal, logOut, userInitials, canChangePassword, isBetaEnabled, canEnableBeta, user }
}

})